import React, { useState } from 'react'
import cn from 'classnames'
import '../App.css'
import { GameOver } from './gameOver/GameOver'

export const Game = ({enemy}) => {

    const data =[ {value:null , positon:0},{value:null , positon:1},{value:null , positon:2},
        {value:null , positon:3},{value:null , positon:4},{value:null , positon:5},
        {value:null , positon:6},{value:null , positon:7},{value:null , positon:8},]
        



    const winConditions =[[0,1,2],[0,3,6],[0,4,8],
                [3,4,5],[1,4,7],[2,4,6],
                [6,7,8],[2,5,8]];



    const [XorO , setXorO] = useState(data);
    const [value, setValue] = useState('x');
    const [isGameOver , setIsGameOver] = useState(false);
    const [counter, setCouner] = useState(9)
    const [activePosition , setActivePosition] = useState(null)
    const [winner , setWinner]= useState([])



    const changeData = (position)=>{
        setXorO(()=>{
    
            let newXorO = XorO.map((item , i) =>{
              if(i === position && !item.value && !isGameOver){
                item.value = value;
                setCouner((prev)=>prev-1)
                toggleValue()

                return item
              }
              
              return item
            })
            checkGameIsOver(newXorO,value)
            return newXorO
          })
        
      }

      const bot =()=>{
        if(!checkGameIsOver(XorO,'x')){
            let PossibleItems = XorO.filter(item => !item.value)
            let PossiblePositions = PossibleItems.map(item=> item.positon)
    
            let rand = Math.floor(Math.random()*(PossiblePositions.length -1))
    
    
            let randPos = PossiblePositions[rand]
    
            setXorO(()=>{
                let newXorO =XorO.map((item , i )=>{
                    if(i === randPos && !isGameOver&& !item.value){
                        item.value = 'o';
                        toggleValue()
                        setCouner((prev)=>prev-1)
                        return item
                    }
                    return item
                })
    
                checkGameIsOver(newXorO,'o')
                return newXorO
            })
        }

        
      }
    
      const toggleValue = (initial)=>{
        setValue(prev =>{
          if(initial){
            return initial
          }
          if(prev === 'x'){
            return 'o'
          }
          return 'x'
        })
      }
    
      const checkGameIsOver =(newXorO,value = 'x')=>{
       
        let end =()=>{
             for(let i= 0 ; i<winConditions.length; i++){
            let coinsideces = 0;
            winConditions[i].forEach((win,index) =>{
            newXorO.filter(item => item.value === value).forEach(item=>{
                if(item.positon === win)coinsideces++
              })
            })
            
            if(coinsideces ===3){
              setWinner(winConditions[i])
               setIsGameOver(true)
               setActivePosition(i);
               return true
              }
            }
            return false
        }

        return end()


    }
    
    
      const replay = ()=>{
        setXorO(()=>(
          XorO.map((item) =>{
            item.value = null;
            return item
          })
        ))
        toggleValue('x');
        setIsGameOver(false)
        setCouner(9)
        setActivePosition(null)
      }
    

  return (
    <div className={cn('game-wrapper')}>

    <GameOver isGameOver={isGameOver} value={value} replay={replay} counter={counter} enemy ={enemy}/>

    <div className='info'><span className='turn'>{value}</span> turn</div>
    <input value={'Replay'} type={'button'} className ='replay' onClick={()=>replay()}/>

    <div className='wrappper'>




      {XorO.map((item , i) =>(
        <div key={i}
         className={cn('wrapperItem',{
          ['win-x']: item.value =='x'&& isGameOver&& winner.includes(i),
          ['win-o']:item.value =='o'&& isGameOver&& winner.includes(i),
         })}
         onClick={()=>{
  
            changeData(i);
            enemy=='bot'&&setTimeout(bot,200)

        }}
         ><div>{item.value}</div></div>
      ))}
        <div className={activePosition !== null? 'cross position'+ activePosition +' active':' cross'}></div>


    </div>
  </div>
  )
}
